// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".history_history__1_5mT {\n  white-space: pre-wrap;\n  margin-top: 25px;\n  font-weight: normal;\n  line-height: 120%;\n}\n.history_history__1_5mT h3 {\n  margin-bottom: 15px;\n}", ""]);
// Exports
exports.locals = {
	"history": "history_history__1_5mT"
};
module.exports = exports;
